module.exports = __webpack_public_path__ + "static/media/Calendar.653078b1.svg";